import React, { useState, useEffect, useRef, useContext } from "react";
import { IoMdClose } from "react-icons/io";
import "../../styles/_inputField.scss";

import { PartialType } from "./Revoke/PartialRevokeTable";

const UnitsSelectModal = ({ modalOpen, fundDetails, handleUnitChange }) => {
  const inputRef = useRef(null);
  const [selectedUnits, setSelectedUnits] = useState(
    fundDetails.unitsAvailable || 0.0
  );
  const type = useContext(PartialType);
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  function truncateText(text, maxLength = 80) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    } else {
      return text;
    }
  }
  useEffect(() => {
    // Focus the input field when the component mounts
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[400px] ${
          fundDetails.name.length > 43 ? "!min-h-[296px]" : "!min-h-[280px]"
        } !max-h-[50vh]    !p-0 !text-left `}
      >
        <div className=" w-full !h-auto !p-6 flex flex-col">
          <div className=" flex justify-between items-center text-base font-bold h-[38px]">
            <p className=" flex flex-col justify-between">
              <span>Select Amount / No. of Unit</span>{" "}
              <span>for {type === "revoke" ? "Revoke" : "Invoke"}</span>
            </p>
            <IoMdClose
              className=" w-[20px] h-[20px] font-bold cursor-pointer"
              onClick={() => modalOpen(false)}
            />
          </div>
          <p
            title={fundDetails?.name ? fundDetails.name : ""}
            className=" w-full text-[#6f6f6f] font-semibold mt-6 text-base"
          >
            {truncateText(fundDetails?.name)}
          </p>
          <p className=" w-fit py-[2px] px-[10px] text-xs  bg-[#a0ff77] rounded-xl mt-4 font-medium ">
            No of Units
          </p>
          <div className="min-h-[45px] border border-[#e0e0e0] flex px-4 items-center mt-2 justify-between rounded">
            <input
              ref={inputRef}
              type="text"
              value={selectedUnits}
              step="1"
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\D/g, "");

                if (parseInt(input) > fundDetails.maximumUnits) return;

                setSelectedUnits(input);
              }}
              className="h-full focus:outline-none w-[35%] "
            />
            <p className=" text-xs text-[#848484] ">
              Selected Amount:{" "}
              <span className=" text-black">
                {formatToIndianRupees(selectedUnits * fundDetails.unitPrice)}
              </span>
            </p>
          </div>
          <button
            className=" py-[7px] px-4 bg-[#00394d] text-sm font-semibold text-white w-fit ml-auto mr-auto rounded mt-6 "
            onClick={() => {
              handleUnitChange(
                parseInt(selectedUnits),
                fundDetails.index,
                fundDetails.unitPrice
              );
              modalOpen(false);
            }}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnitsSelectModal;
